function isRawResponse(response) {
  return !('results' in response);
}

module.exports = { isRawResponse };
